import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for C516 (S/C Closeout)
// ============================================================

export interface CloseoutItem {
  fc110_01: string;    // S/C No
  fc110_11: string;    // S/C Date
  fc110_12: string;    // Customer name (F104 lookup)
  fc110_59: string;    // Performance customer code
  fc110_99: number;    // Gross profit (BR-F07)
  fc110_100: number;   // Gross profit rate % (BR-F08)
}

export interface QueryResponse {
  items: CloseoutItem[];
  total: number;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c516Api = {
  /** Query S/C items eligible for closeout */
  async query(params: {
    sc_start?: string;
    sc_end?: string;
    date_start?: string;
    date_end?: string;
    sales_start?: string;
    sales_end?: string;
  }): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c516/query', params);
    return res.data;
  },

  /** Execute batch closeout for selected S/C items */
  async execute(scNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/c516/execute', {
      sc_nos: scNos,
    });
    return res.data;
  },
};
